<template>
  <div v-if="isYouthTab" class="space-y-4">
    <PassengerTypeCard
      :title="$t('general.passengers')"
      :description="$t('main.cabinClass.rules.youth.domestic')"
      :passenger-state="passengers.yth"
      @onPassengersAmountChange="emit('onPassengersChange', { yth: $event })"
      @onError="emit('onChangeError', { yth: $event })"
    />
    <YouthRules />
  </div>
  <div v-else class="space-y-2">
    <PassengerTypeCard
      :title="$t('main.passengers.adults')"
      :description="$t('main.cabinClass.rules.adults.domestic')"
      :additional-description="$t('main.cabinClass.rules.adults.international')"
      :passenger-state="passengers.adt"
      @onPassengersAmountChange="emit('onPassengersChange', { adt: $event })"
      @onError="emit('onChangeError', { adt: $event })"
    />
    <PassengerTypeCard
      :title="$t('main.passengers.children')"
      :description="$t('main.cabinClass.rules.children.domestic')"
      :additional-description="
        $t('main.cabinClass.rules.children.international')
      "
      :passenger-state="passengers.chd"
      @onPassengersAmountChange="emit('onPassengersChange', { chd: $event })"
      @onError="emit('onChangeError', { chd: $event })"
    />
    <PassengerTypeCard
      :title="$t('main.passengers.infants')"
      :description="$t('main.cabinClass.rules.infants.domestic')"
      :passenger-state="passengers.inf"
      @onPassengersAmountChange="emit('onPassengersChange', { inf: $event })"
      @onError="emit('onChangeError', { inf: $event })"
    />
  </div>
</template>

<script setup lang="ts">
  import type { PassengersState, Passengers } from 'shared';

  import { PassengerTypeCard } from '@/entities/passenger-type-card';

  import YouthRules from './YouthRules.vue';

  defineProps<{
    isYouthTab: boolean;
    passengers: PassengersState;
    source: string;
  }>();

  const emit = defineEmits<{
    (e: 'onPassengersChange', state: Partial<Passengers>): void;
    (e: 'onChangeError', info: { [type: string]: string }): void;
  }>();
</script>
